import { render, staticRenderFns } from "./Thirdparty.vue?vue&type=template&id=a21a8f54&scoped=true"
import script from "./Thirdparty.vue?vue&type=script&lang=js"
export * from "./Thirdparty.vue?vue&type=script&lang=js"
import style0 from "./Thirdparty.vue?vue&type=style&index=0&id=a21a8f54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21a8f54",
  null
  
)

export default component.exports